/**
 * 全局性的国际化
 */
import BrowserUtil from '../../util/BrowserUtil';
import LangEn from './i18n/LangEn';
import LangZh from './i18n/LangZh';

export default class Lang {
  //当前使用的语言，默认中文
  lang: string = 'zh';

  //全局的一个store对象
  private static singleton: Lang | null = null;

  //使用懒加载模式。
  static getSingleton(): Lang {
    if (Lang.singleton == null) {
      Lang.singleton = new Lang();

      //读取默认的语言
      let lang = BrowserUtil.browserLang();
      let localLang = localStorage.getItem('_lang');
      if (localLang === 'zh' || localLang === 'en') {
        lang = localLang;
      }
      Lang.singleton.lang = lang;
      console.info('current lang: ', lang);
    }

    return Lang.singleton;
  }

  //快捷获取一种语言对应的文字。
  static t(key: string, ...params: any[]): string {
    let json: { [key: string]: any } = LangEn;

    let lang = Lang.getSingleton().lang;
    if (lang == 'zh') {
      json = LangZh;
    }

    let keyParts: string[] = key.split('.');
    let jsonBody: any = json;
    for (let i = 0; i < keyParts.length; i++) {
      let part: string = keyParts[i];
      jsonBody = jsonBody[part];
      if (jsonBody === undefined || jsonBody === null) {
        // 完全兼容旧版本：找不到key对应的内容，直接返回key（无警告）
        return key;
      }
    }

    //到这里已经找到了
    if (typeof jsonBody !== 'string') {
      // 完全兼容旧版本：不是字符串也返回key
      return key;
    }

    // 如果没有参数，直接返回字符串
    if (!params || params.length === 0) {
      return jsonBody;
    }

    // 保存原始字符串
    let result = jsonBody;
    
    // 优先检查是否有带数字的占位符 {0}, {1} 等
    // 使用更精确的匹配：确保 {数字} 是独立的占位符
    const hasNumberedPlaceholders = /\{[0-9]+\}/.test(result);
    
    if (hasNumberedPlaceholders) {
      // 处理带数字的占位符 {0}, {1}, {2} 等
      // 按照参数顺序替换
      for (let i = 0; i < params.length; i++) {
        const placeholder = new RegExp(`\\{${i}\\}`, 'g');
        // 只替换确实存在的占位符
        if (placeholder.test(result)) {
          result = result.replace(placeholder, String(params[i] || ''));
        }
      }
      
      // 注意：我们不处理剩余未匹配的 {数字}，保持原样，这是为了兼容性
    } else {
      // 处理旧版的 {} 占位符（顺序替换）
      let paramIndex = 0;
      // 每次替换第一个 {}
      while (result.indexOf('{}') !== -1 && paramIndex < params.length) {
        result = result.replace('{}', String(params[paramIndex] || ''));
        paramIndex++;
      }
      // 如果还有 {} 但参数用完了，保持 {} 不变（兼容旧版行为）
    }

    return result;
  }

  // 新增一个辅助方法，用于替换占位符但不改变原有 t() 方法的行为
  static format(template: string, ...params: any[]): string {
    if (!template) return template;
    
    let result = template;
    
    // 优先检查是否有带数字的占位符
    if (/\{[0-9]+\}/.test(result)) {
      // 替换带数字的占位符
      for (let i = 0; i < params.length; i++) {
        const placeholder = new RegExp(`\\{${i}\\}`, 'g');
        result = result.replace(placeholder, String(params[i] || ''));
      }
    } else if (result.includes('{}')) {
      // 替换顺序占位符
      let paramIndex = 0;
      while (result.indexOf('{}') !== -1 && paramIndex < params.length) {
        result = result.replace('{}', String(params[paramIndex] || ''));
        paramIndex++;
      }
    }
    
    return result;
  }
}